import React, {useEffect, useState} from "react";
import {Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from "@mui/material";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import AppBreadcrumbs from "../../components/Breadcrumbs/AppBreadcrumbs";
import {cardSx, headerCellSx, topCellSx} from "./styles";
import {releaseNoteHeader} from "../../shared/constants/tableHeaders";
import {fetchChangelog, parseChangelog} from "../../utils/releaseNotesUtil";

const ReleaseNoteDetails = ({details}: { details: string }) => {
    if (!details.trim()) return <Box sx={{p: 2}}><em>Loading release notes…</em></Box>;
    const releases = parseChangelog(details);
    if (!releases.length) return <Box sx={{p: 2}}><em>No releases found in CHANGELOG.md.</em></Box>;

    return (<TableContainer component={Paper}>
            <Table aria-label="release notes">
                <TableHead>
                    <TableRow>
                        {releaseNoteHeader.map((h) => (
                            <TableCell key={h.id} sx={headerCellSx(h.width)}>{h.name}</TableCell>))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {releases.map((r, i) => (<TableRow key={`${r.version || "v"}-${i}`}>
                            <TableCell sx={topCellSx}>Release {r.version}</TableCell>
                            <TableCell>
                                {!!r.features.length && (<>
                                        <u>Upcoming Features & Improvements</u>
                                        <ul>
                                            {r.features.map((f, j) => (<li key={`${r.version}-feature-${j}`}>
                                                    <ReactMarkdown remarkPlugins={[remarkGfm]}>{f}</ReactMarkdown>
                                                </li>))}
                                        </ul>
                                    </>)}
                                {!!r.bugFixes.length && (<>
                                        <u>Bug Fixes</u>
                                        <ul>
                                            {r.bugFixes.map((b, j) => (<li key={`${r.version}-bug-${j}`}>
                                                    <ReactMarkdown remarkPlugins={[remarkGfm]}>{b}</ReactMarkdown>
                                                </li>))}
                                        </ul>
                                    </>)}
                            </TableCell>
                            <TableCell sx={topCellSx}>
                                {r.date ? new Date(r.date).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric"
                                }) : ""}
                            </TableCell>
                        </TableRow>))}
                </TableBody>
            </Table>
        </TableContainer>);
};

const ReleaseNotePage: React.FC = () => {
    const [md, setMd] = useState("");
    useEffect(() => {
        fetchChangelog().then(setMd).catch(() => setMd(""));
    }, []);

    return (<Box>
            <AppBreadcrumbs breadcrumbList={[{name: "Home", routePath: "/home"}, {name: "Release", routePath: ""}]}/>
            <Paper sx={cardSx}>
                <Typography variant="h6" sx={{mb: 2, fontWeight: 600}}>Release Notes</Typography>
                <ReleaseNoteDetails details={md}/>
            </Paper>
        </Box>);
};

export default ReleaseNotePage;
